import { useEffect, useState } from 'react';
import axios from 'axios';

// Charte §6 : au-delà d'une seconde d'attente, un indicateur de chargement (liseré en haut de l'écran).
export const NetworkActivity = () => {
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    let pending = 0;
    let timer = null;
    let stop = null;
    // LOT 8.3.4 · la barre ne bouge que pendant un vrai chargement · jamais pour les appels de fond, jamais plus de 8 s
    let geste = Date.now();
    const marque = () => { geste = Date.now(); };
    window.addEventListener('pointerdown', marque, true); window.addEventListener('keydown', marque, true); window.addEventListener('popstate', marque);
    // un appel n'allume la barre que s'il suit un geste (clic, touche, navigation) de moins de 1,5 s · les rafraîchissements de fond restent invisibles
    const fond = (c) => Date.now() - geste > 1500 || c?.silent || /realtime|poll|import-pdf\/|notifications|unread|heartbeat|presence|\/suites\/journal|credits\/(balance|solde)/.test(c?.url || '');
    const update = () => {
      if (pending > 0 && !timer) timer = setTimeout(() => { timer = null; if (pending > 0) { setSlow(true); clearTimeout(stop); stop = setTimeout(() => setSlow(false), 8000); } }, 1000);
      if (pending === 0) { if (timer) { clearTimeout(timer); timer = null; } clearTimeout(stop); setSlow(false); }
    };
    const start = (config) => { if (!fond(config)) { config.__compte = true; pending += 1; update(); } return config; };
    const end = (x) => { if (x?.config?.__compte) { pending = Math.max(0, pending - 1); update(); } return x; };
    const endErr = (e) => { end(e); return Promise.reject(e); };
    const req = axios.interceptors.request.use(start);
    const res = axios.interceptors.response.use(end, endErr);
    return () => { axios.interceptors.request.eject(req); axios.interceptors.response.eject(res); if (timer) clearTimeout(timer); clearTimeout(stop); window.removeEventListener('pointerdown', marque, true); window.removeEventListener('keydown', marque, true); window.removeEventListener('popstate', marque); };
  }, []);
  if (!slow) return null;
  return (
    <div className="ux-progress" role="progressbar" aria-label="Chargement en cours" aria-busy="true" data-testid="network-activity">
      <div className="ux-progress-bar" />
    </div>
  );
};
